import request from '@/utils/request'

export function articleList () {
    return request({
        url: 'article/list',
        method: 'get',
        params: {}
    })
}

export function articleDetail (data) {
    return request({
        url: 'article/detail',
        method: 'get',
        params: data
    })
}

export function articleAll (data) {
    return request({
        url: 'article/all',
        method: 'get',
        params: data
    })
}

export function articleCategory (data) {
    return request({
        url: 'article/category',
        method: 'get',
        params: data
    })
}
